import { render, staticRenderFns } from "./InventoryBuyerProduct.vue?vue&type=template&id=4845a9b5&"
import script from "./InventoryBuyerProduct.vue?vue&type=script&lang=js&"
export * from "./InventoryBuyerProduct.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBuyerProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports